export default function ApSpeed() {
  return (
    <div className="animate-slide-up">
      <div className="page-header">
        <h1 className="page-title">AP Velocity</h1>
        <p className="page-subtitle">Accounts payable processing speed metrics.</p>
      </div>
      <p className="text-muted-foreground">Coming soon.</p>
    </div>
  );
}
